module.exports = __webpack_public_path__ + "static/karussel3-a18ffa6172af92755b4918de67f520cf.jpg";